export const ASSETS_SELECTED = 'ASSETS_SELECTED'
